import { relations } from "@/mocks/homeContent";

export default function RelationSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-14 md:px-6 md:pb-20">
      <div className="rounded-xl border border-background-200 bg-gradient-to-br from-background-100 to-background-200/60 p-7 md:p-10">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-600">关系链图谱</p>
            <h3 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{relations.title}</h3>
          </div>
        </div>
        <p className="mt-4 max-w-3xl text-[15px] leading-relaxed text-foreground-600">{relations.intro}</p>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {relations.pairs.map((p) => (
            <div key={p.right} className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50/70 px-5 py-5">
              <span className="flex-1 rounded-md bg-background-100 px-4 py-3 text-center font-heading text-[15px] font-semibold text-foreground-900 ring-1 ring-background-200">
                {p.left}
              </span>
              <div className="flex w-24 shrink-0 flex-col items-center gap-1">
                <span className="whitespace-nowrap rounded-full bg-accent-500 px-2 py-0.5 text-[10px] font-medium tracking-wide text-foreground-950">
                  {p.rel}
                </span>
                <i className="ri-arrow-right-line text-lg text-accent-600" />
              </div>
              <span className="flex-1 rounded-md bg-background-100 px-4 py-3 text-center font-heading text-[15px] font-semibold text-foreground-900 ring-1 ring-background-200">
                {p.right}
              </span>
            </div>
          ))}
        </div>

        <p className="mt-5 flex items-start gap-2 text-xs leading-relaxed text-foreground-500">
          <i className="ri-information-line mt-0.5 shrink-0 text-primary-600" />
          {relations.footnote}
        </p>
      </div>
    </section>
  );
}